<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Indicadores Gerenciais
      </p>
    </div>
    <section>
      <component-superior
        subPrimeiro="Total consumo no período"
        :primeiro="
          highlights.ValorTotal
            ? formatarPreco(highlights.ValorTotal)
            : formatarPreco(0)
        "
        subSegundo="Número de produtos consumidos"
        :segundo="
          highlights.QuantidadeTotal
            ? formatarInteiro(highlights.QuantidadeTotal)
            : formatarInteiro(0)
        "
        subTerceiro="Número de Vouchers"
        :terceiro="
          highlights.NumeroAtendimentos
            ? formatarInteiro(highlights.NumeroAtendimentos)
            : formatarInteiro(0)
        "
        subQuarto="Ticket médio por Atendimento"
        :quarto="
          highlights.TicketMedio
            ? formatarPreco(highlights.TicketMedio)
            : formatarPreco(0)
        "
      ></component-superior>
    </section>

    <section>
      <filtros-indicadores-component
        @emitirFiltros="getFiltros"
      ></filtros-indicadores-component>
    </section>

    <section class="q-mt-xl">
      Consumo
      <LineChart
        :height="400"
        :datasets="dadosGraficoBarChartConsumo.datasets"
        :labels="dadosGraficoBarChartConsumo.labels"
        formatType="currency"
      />
    </section>

    <section class="q-mt-md">
      Atendimentos
      <LineChart
        :height="400"
        :datasets="dadosGraficoBarChartAtendimento.datasets"
        :labels="dadosGraficoBarChartAtendimento.labels"
        formatType="integer"
      />
    </section>

    <section class="charts-section">
      <div class="charts-grid">
        <div class="chart-item">
          <q-table
            flat
            :title="'Top ' + top + ' Funcionários ' + total"
            table-header-class="bg-accent text-width-bold"
            :rows="rows1"
            :loading="disable"
            dense
            :columns="columns1"
            color="primary"
            title-class="text-brand-5 text-weight-bold"
            v-model:pagination="pagination"
            class="q-mt-md tabela-tamanho-fixo"
            row-key="name"
            hide-pagination
            @request="handleRequest"
          >
            <template #body-cell-centro="props">
              <q-td>
                <span>{{ props.row.cost_center_code }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span>{{ props.row.cost_center_description }}</span>
              </q-td>
            </template>
            <template #body-cell-ciclo="props">
              <q-td>
                <span v-if="props.row.prazo_minimo">{{
                  props.row.prazo_minimo
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span
                  >({{
                    props.row.quantidade_retirada -
                    props.row.quantidade_total_regra
                  }})</span
                >
              </q-td>
            </template>
            <template #body-cell-prazo_maximo="props">
              <q-td>
                <span v-if="props.row.prazo_maximo">{{
                  props.row.prazo_maximo
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </q-td>
            </template>
            <template #body-cell-critico="props">
              <q-td>
                <span v-if="props.row.critico == 1">SIM</span>
                <span v-else>NÃO</span>
              </q-td>
            </template>
            <template #body-cell-Status="props">
              <q-td>
                <span v-if="props.row.Status == 'ATRASADO'"
                  ><div
                    style="background-color: #e23431"
                    class="status-circulo"
                  ></div
                ></span>
                <span v-if="props.row.Status == 'Nunca retirou'"
                  ><div
                    style="background-color: #eef3fe"
                    class="status-circulo"
                  ></div
                ></span>
                <span v-if="props.row.Status == 'ATENÇÃO'"
                  ><div
                    style="background-color: #efe00b"
                    class="status-circulo"
                  ></div
                ></span>
                <span v-if="props.row.Status == 'OK'"
                  ><div
                    style="background-color: #58c16d"
                    class="status-circulo"
                  ></div
                ></span>
              </q-td>
            </template>
            <template #body-cell-total="props">
              <q-td>
                <span>{{ formatarPreco(props.row.total) }}</span>
              </q-td>
            </template>
          </q-table>
        </div>
        <div class="chart-item">
          <PieChart
            titulo="Top Funcionários"
            :labels="dadosGraficoTipoIntegracao.labels"
            :datasets="dadosGraficoTipoIntegracao.datasets"
          />
        </div>
      </div>
    </section>

    <section class="charts-section">
      <div class="charts-grid">
        <div class="chart-item">
          <q-table
            flat
            :title="'TOP ' + top + ' Centros de Custo ' + total"
            table-header-class="bg-accent text-width-bold"
            :rows="rows2"
            :loading="disable"
            :columns="columns2"
            dense
            color="primary"
            v-model:pagination="pagination"
            class="q-mt-md tabela-tamanho-fixo"
            title-class="text-brand-5 text-weight-bold"
            row-key="name"
            hide-pagination
            @request="handleRequest"
          >
            <template #body-cell-centro="props">
              <q-td>
                <span>{{ props.row.cost_center_code }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span>{{ props.row.cost_center_description }}</span>
              </q-td>
            </template>

            <template #body-cell-total="props">
              <q-td>
                <span>{{ formatarPreco(props.row.total) }}</span>
              </q-td>
            </template>
          </q-table>
        </div>
        <div class="chart-item">
          <PieChart
            titulo="Top Centros de Custo"
            :labels="dadosGraficoTipoCentro.labels"
            :datasets="dadosGraficoTipoCentro.datasets"
          />
        </div>
      </div>
    </section>

    <section class="charts-section">
      <div class="charts-grid">
        <div class="chart-item">
          <q-table
            flat
            :title="
              'Top ' + top + ' Consumo Por Nome dos Centros de Custo ' + total
            "
            table-header-class="bg-accent text-width-bold"
            :rows="rows3"
            dense
            :loading="disable"
            title-class="text-brand-5 text-weight-bold"
            :columns="columns3"
            color="primary"
            v-model:pagination="pagination"
            class="q-mt-md tabela-tamanho-fixo"
            row-key="name"
            hide-pagination
            @request="handleRequest"
          >
            <template #body-cell-centro="props">
              <q-td>
                <span>{{ props.row.cost_center_code }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span>{{ props.row.cost_center_description }}</span>
              </q-td>
            </template>

            <template #body-cell-total="props">
              <q-td>
                <span>{{ formatarPreco(props.row.total) }}</span>
              </q-td>
            </template>
          </q-table>
        </div>
        <div class="chart-item">
          <PieChart
            titulo="Top Consumo Por Nome dos Centros de Custo"
            :labels="dadosGraficoTipoCentroNome.labels"
            :datasets="dadosGraficoTipoCentroNome.datasets"
          />
        </div>
      </div>
    </section>

    <section class="charts-section">
      <div class="charts-grid">
        <div class="chart-item">
          <q-table
            flat
            :title="'TOP ' + top + ' Produtos ' + total"
            table-header-class="bg-accent text-width-bold"
            :rows="rows4"
            :loading="disable"
            title-class="text-brand-5 text-weight-bold"
            :columns="columns4"
            color="primary"
            dense
            v-model:pagination="pagination"
            class="q-mt-md tabela-tamanho-fixo"
            row-key="name"
            hide-pagination
            @request="handleRequest"
          >
            <template #body-cell-centro="props">
              <q-td>
                <span>{{ props.row.cost_center_code }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span>{{ props.row.cost_center_description }}</span>
              </q-td>
            </template>

            <template #body-cell-total="props">
              <q-td>
                <span>{{ formatarPreco(props.row.total) }}</span>
              </q-td>
            </template>
          </q-table>
        </div>
        <div class="chart-item">
          <PieChart
            titulo="Top Produtos"
            :labels="dadosGraficoTipoProduto.labels"
            :datasets="dadosGraficoTipoProduto.datasets"
          />
        </div>
      </div>
    </section>

    <section class="charts-section">
      <div class="charts-grid">
        <div class="chart-item">
          <q-table
            flat
            :title="'Top ' + top + ' Grupos ' + total"
            table-header-class="bg-accent text-width-bold"
            :rows="rows5"
            :loading="disable"
            :columns="columns5"
            color="primary"
            dense
            title-class="text-brand-5 text-weight-bold"
            v-model:pagination="pagination"
            class="q-mt-md tabela-tamanho-fixo"
            row-key="name"
            hide-pagination
            @request="handleRequest"
          >
            <template #body-cell-centro="props">
              <q-td>
                <span>{{ props.row.cost_center_code }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span>{{ props.row.cost_center_description }}</span>
              </q-td>
            </template>

            <template #body-cell-total="props">
              <q-td>
                <span>{{ formatarPreco(props.row.total) }}</span>
              </q-td>
            </template>
          </q-table>
        </div>
        <div class="chart-item">
          <PieChart
            titulo="Top Grupos"
            :labels="dadosGraficoTipoGrupo.labels"
            :datasets="dadosGraficoTipoGrupo.datasets"
          />
        </div>
      </div>
    </section>

    <section class="charts-section">
      <div class="charts-grid">
        <div class="chart-item">
          <q-table
            flat
            :title="'Top ' + top + ' Contas ' + total"
            table-header-class="bg-accent text-width-bold"
            :rows="rows6"
            :loading="disable"
            :columns="columns6"
            color="primary"
            v-model:pagination="pagination"
            title-class="text-brand-5 text-weight-bold"
            class="q-mt-md tabela-tamanho-fixo"
            dense
            row-key="name"
            hide-pagination
            @request="handleRequest"
          >
            <template #body-cell-centro="props">
              <q-td>
                <span>{{ props.row.cost_center_code }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span>{{ props.row.cost_center_description }}</span>
              </q-td>
            </template>
            <template #body-cell-ciclo="props">
              <q-td>
                <span v-if="props.row.prazo_minimo">{{
                  props.row.prazo_minimo
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
                <span class="q-ml-sm q-mr-sm">-</span>
                <span
                  >({{
                    props.row.quantidade_retirada -
                    props.row.quantidade_total_regra
                  }})</span
                >
              </q-td>
            </template>
            <template #body-cell-prazo_maximo="props">
              <q-td>
                <span v-if="props.row.prazo_maximo">{{
                  props.row.prazo_maximo
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </q-td>
            </template>
            <template #body-cell-critico="props">
              <q-td>
                <span v-if="props.row.critico == 1">SIM</span>
                <span v-else>NÃO</span>
              </q-td>
            </template>
            <template #body-cell-Status="props">
              <q-td>
                <span v-if="props.row.Status == 'ATRASADO'"
                  ><div
                    style="background-color: #e23431"
                    class="status-circulo"
                  ></div
                ></span>
                <span v-if="props.row.Status == 'Nunca retirou'"
                  ><div
                    style="background-color: #eef3fe"
                    class="status-circulo"
                  ></div
                ></span>
                <span v-if="props.row.Status == 'ATENÇÃO'"
                  ><div
                    style="background-color: #efe00b"
                    class="status-circulo"
                  ></div
                ></span>
                <span v-if="props.row.Status == 'OK'"
                  ><div
                    style="background-color: #58c16d"
                    class="status-circulo"
                  ></div
                ></span>
              </q-td>
            </template>
            <template #body-cell-total="props">
              <q-td>
                <span>{{ formatarPreco(props.row.total) }}</span>
              </q-td>
            </template>
          </q-table>
        </div>
        <div class="chart-item">
          <PieChart
            titulo="Top Contas"
            :labels="dadosGraficoTipoContas.labels"
            :datasets="dadosGraficoTipoContas.datasets"
          />
        </div>
      </div>
    </section>
  </q-page>
</template>

<script>
const columns1 = [
  {
    name: "nome_funcionario",
    label: "Funcionários",
    field: "nome_funcionario",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    field: "total",
    align: "left",
  },
];

const columns2 = [
  {
    name: "centro_de_custo",
    label: "Centro de Custo	",
    field: "centro_de_custo",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    field: "total",
    align: "left",
  },
];

const columns3 = [
  {
    name: "centro_de_custo",
    label: "Centro de Custo	",
    field: "centro_de_custo",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    field: "total",
    align: "left",
  },
];

const columns4 = [
  {
    name: "nome_produto",
    label: "Produto",
    field: "nome_produto",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    field: "total",
    align: "left",
  },
];

const columns5 = [
  {
    name: "nome_funcao",
    label: "Grupo",
    field: "nome_funcao",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    field: "total",
    align: "left",
  },
];

const columns6 = [
  {
    name: "conta",
    label: "Centro de Custo	",
    field: "conta",
    align: "left",
  },
  {
    name: "total",
    label: "Conta",
    field: "total",
    align: "left",
  },
];

import { useStore } from "vuex";
//import { useQuasar } from "quasar";
import { ref, computed, watch, onMounted } from "vue";
import filtrosIndicadoresComponent from "../components/filtrosIndicadoresComponent.vue";
import componentSuperior from "../components/componentSuperior.vue";
import { useRouter } from "vue-router";
import LineChart from "../components/LineChart2.vue";
import PieChart from "../components/PieChart2.vue";
import { useQuasar } from "quasar";

export default {
  components: {
    filtrosIndicadoresComponent,
    LineChart,
    PieChart,
    componentSuperior,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const rows1 = ref([]);
    const rows2 = ref([]);
    const rows3 = ref([]);
    const rows4 = ref([]);
    const rows5 = ref([]);
    const rows6 = ref([]);
    const top = ref("10");
    const highlights = ref("");
    const hoje = new Date();
    hoje.setDate(hoje.getDate() - 16);

    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0"); // Janeiro é 0
    const ano = hoje.getFullYear();

    const data = ref(`${dia}/${mes}/${ano}`);

    //const quasar = useQuasar();
    const disable = ref(true);

    const formatarPreco = (valor) => {
      if (valor == null || valor === undefined) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(parseFloat(valor));
    };

    const formatarInteiro = (valor) => {
      if (valor == null || valor === undefined) return "0";
      return Math.floor(parseFloat(valor)).toLocaleString("pt-BR");
    };

    const dadosGraficoBarChartConsumo = ref({
      labels: [],
      datasets: [
        {
          label: "",
          backgroundColor: "#f87979",
          data: [],
        },
      ],
    });
    const dadosGraficoBarChartAtendimento = ref({
      labels: [],
      datasets: [
        {
          label: "",
          backgroundColor: "#f87979",
          data: [],
        },
      ],
    });

    const dadosGraficoTipoIntegracao = ref({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "#213864",
            "#6AD9B1",
            "#FF6B6B",
            "#4ECDC4",
            "#45B7D1",
            "#96CEB4",
            "#FFEAA7",
            "#DDA0DD",
            "#98D8C8",
            "#F7DC6F",
          ],
        },
      ],
    });

    const dadosGraficoTipoCentro = ref({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "#213864",
            "#6AD9B1",
            "#FF6B6B",
            "#4ECDC4",
            "#45B7D1",
            "#96CEB4",
            "#FFEAA7",
            "#DDA0DD",
            "#98D8C8",
            "#F7DC6F",
          ],
        },
      ],
    });

    const dadosGraficoTipoCentroNome = ref({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "#213864",
            "#6AD9B1",
            "#FF6B6B",
            "#4ECDC4",
            "#45B7D1",
            "#96CEB4",
            "#FFEAA7",
            "#DDA0DD",
            "#98D8C8",
            "#F7DC6F",
          ],
        },
      ],
    });

    const dadosGraficoTipoProduto = ref({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "#213864",
            "#6AD9B1",
            "#FF6B6B",
            "#4ECDC4",
            "#45B7D1",
            "#96CEB4",
            "#FFEAA7",
            "#DDA0DD",
            "#98D8C8",
            "#F7DC6F",
          ],
        },
      ],
    });

    const dadosGraficoTipoGrupo = ref({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "#213864",
            "#6AD9B1",
            "#FF6B6B",
            "#4ECDC4",
            "#45B7D1",
            "#96CEB4",
            "#FFEAA7",
            "#DDA0DD",
            "#98D8C8",
            "#F7DC6F",
          ],
        },
      ],
    });

    const dadosGraficoTipoContas = ref({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "#213864",
            "#6AD9B1",
            "#FF6B6B",
            "#4ECDC4",
            "#45B7D1",
            "#96CEB4",
            "#FFEAA7",
            "#DDA0DD",
            "#98D8C8",
            "#F7DC6F",
          ],
        },
      ],
    });

    const total = ref("");
    const filter = ref("");
    const unidadeDefault = ref("");
    const quasar = useQuasar();
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async (filtros) => {
      quasar.loading.show();
      top.value = filtros && filtros.quantidade ? filtros.quantidade : 10;
      setTimeout(async () => {
        await getConsumo(filtros);
        await getAtendimentos(filtros);
        await getTop10Funcionarios(filtros);
        await getTop10Centros(filtros);
        await getTop10CentrosNome(filtros);
        await getTop10Produtos(filtros);
        await getTop10Grupos(filtros);
        await getTop10Contas(filtros);
        await getTopoIndicadores(filtros);
        quasar.loading.hide();
      }, 1000);
    };

    const getConsumo = async (filtros) => {
      dadosGraficoBarChartConsumo.value.labels = [];
      dadosGraficoBarChartConsumo.value.datasets[0].data = [];

      const response = await store.dispatch("ind/getConsumoGrafico", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial !== "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final !== "" ? filtros.final : undefined,
      });

      const dadosValidos = response.data.filter(
        (e) => e.data && e.total != null && parseFloat(e.total) !== 0
      );

      dadosValidos.sort((a, b) => new Date(a.data) - new Date(b.data));

      dadosValidos.forEach((e) => {
        // Formata a data para dd/mm/yyyy, se necessário
        const [year, month, day] = e.data.split("-");
        const dataFormatada = `${day}/${month}/${year}`;

        dadosGraficoBarChartConsumo.value.labels.push(dataFormatada);
        dadosGraficoBarChartConsumo.value.datasets[0].data.push(
          parseFloat(e.total)
        );
      });

      disable.value = false;
    };

    const getAtendimentos = async (filtros) => {
      dadosGraficoBarChartAtendimento.value.labels = [];
      dadosGraficoBarChartAtendimento.value.datasets[0].data = [];

      const response = await store.dispatch("ind/getAtendimentosGrafico", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial !== "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final !== "" ? filtros.final : undefined,
      });

      const dadosValidos = response.data.filter(
        (e) => e.data && e.total != null && parseInt(e.total) !== 0
      );

      dadosValidos.sort((a, b) => new Date(a.data) - new Date(b.data));

      dadosValidos.forEach((e) => {
        // Converte de "YYYY-MM-DD" para "DD/MM/YYYY"
        const [year, month, day] = e.data.split("-");
        const dataFormatada = `${day}/${month}/${year}`;

        dadosGraficoBarChartAtendimento.value.labels.push(dataFormatada);
        dadosGraficoBarChartAtendimento.value.datasets[0].data.push(
          parseInt(e.total)
        );
      });

      disable.value = false;
    };

    const getTop10Funcionarios = async (filtros) => {
      dadosGraficoTipoIntegracao.value.labels = [];
      dadosGraficoTipoIntegracao.value.datasets[0].data = [];
      let response1 = await store.dispatch("ind/getTop10Funcionarios", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
        top:
          filtros && filtros.quantidade != "" ? filtros.quantidade : undefined,
      });

      let response2 = await store.dispatch("ind/getTop10FuncionariosPadrao", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
        top:
          filtros && filtros.quantidade != "" ? filtros.quantidade : undefined,
      });

      rows1.value = response2.data;

      response1.data.forEach((e) => {
        const valor = e.total == null ? 0 : parseFloat(e.total);
        dadosGraficoTipoIntegracao.value.labels.push(e.nome_funcionario);
        dadosGraficoTipoIntegracao.value.datasets[0].data.push(valor);
      });

      disable.value = false;
    };

    const getTop10Centros = async (filtros) => {
      dadosGraficoTipoCentro.value.labels = [];
      dadosGraficoTipoCentro.value.datasets[0].data = [];
      let response = await store.dispatch("ind/getTop10CentrosPadrao", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
        top:
          filtros && filtros.quantidade != "" ? filtros.quantidade : undefined,
      });

      rows2.value = response.data;

      response.data.forEach((e) => {
        dadosGraficoTipoCentro.value.labels.push(e.centro_de_custo);

        const valor = parseFloat(e.total);
        dadosGraficoTipoCentro.value.datasets[0].data.push({
          value: valor,
          formatted: formatarPreco(valor),
        });
      });

      disable.value = false;
    };

    const getTop10CentrosNome = async (filtros) => {
      dadosGraficoTipoCentroNome.value.labels = [];
      dadosGraficoTipoCentroNome.value.datasets[0].data = [];
      let response = await store.dispatch("ind/getTop10CentrosPadraoNome", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
        top:
          filtros && filtros.quantidade != "" ? filtros.quantidade : undefined,
      });

      rows3.value = response.data;

      response.data.forEach((e) => {
        dadosGraficoTipoCentroNome.value.labels.push(e.centro_de_custo);

        const valor = parseFloat(e.total);
        dadosGraficoTipoCentroNome.value.datasets[0].data.push({
          value: valor,
          formatted: formatarPreco(valor),
        });
      });

      disable.value = false;
    };

    const getTop10Produtos = async (filtros) => {
      dadosGraficoTipoProduto.value.labels = [];
      dadosGraficoTipoProduto.value.datasets[0].data = [];
      let response = await store.dispatch("ind/getTop10Produtos", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
        top:
          filtros && filtros.quantidade != "" ? filtros.quantidade : undefined,
      });

      rows4.value = response.data;

      response.data.forEach((e) => {
        dadosGraficoTipoProduto.value.labels.push(e.nome_produto);

        const valor = parseFloat(e.total);
        dadosGraficoTipoProduto.value.datasets[0].data.push({
          value: valor,
          formatted: formatarPreco(valor),
        });
      });

      disable.value = false;
    };

    const getTop10Grupos = async (filtros) => {
      dadosGraficoTipoGrupo.value.labels = [];
      dadosGraficoTipoGrupo.value.datasets[0].data = [];
      let response = await store.dispatch("ind/getTop10Grupos", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
        top:
          filtros && filtros.quantidade != "" ? filtros.quantidade : undefined,
      });

      rows5.value = response.data;

      response.data.forEach((e) => {
        dadosGraficoTipoGrupo.value.labels.push(e.nome_funcao);

        const valor = parseFloat(e.total);
        dadosGraficoTipoGrupo.value.datasets[0].data.push({
          value: valor,
          formatted: formatarPreco(valor),
        });
      });

      disable.value = false;
    };

    const getTop10Contas = async (filtros) => {
      dadosGraficoTipoContas.value.labels = [];
      dadosGraficoTipoContas.value.datasets[0].data = [];
      let response = await store.dispatch("ind/getTop10Contas", {
        vendor: unidadeDefault.value.nome,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : data.value,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
        top:
          filtros && filtros.quantidade != "" ? filtros.quantidade : undefined,
      });

      rows6.value = response.data;

      response.data.forEach((e) => {
        dadosGraficoTipoContas.value.labels.push(e.conta);

        const valor = parseFloat(e.total);
        dadosGraficoTipoContas.value.datasets[0].data.push({
          value: valor,
          formatted: formatarPreco(valor),
        });
      });

      disable.value = false;
    };

    const getTopoIndicadores = async (filtros) => {
      let response = await store.dispatch("ind/getTopoIndicadores", {
        vendor_id: unidadeDefault.value.id,
        initial_date:
          filtros && filtros.inicial != "" ? filtros.inicial : undefined,
        final_date: filtros && filtros.final != "" ? filtros.final : undefined,
      });

      highlights.value = response.data.return.highlights;
    };

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidadeDefault.value = store.state.org.unidadeData;
    };
    onMounted(getUnidade);
    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const getFiltros = async (filtros) => {
      getDados(filtros);
    };

    const movimento = async (id) => {
      router.push({ name: "ind-estoque-movimento", params: { id: id } });
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidadeDefault.value = store.state.org.unidadeData;
      }
    );

    return {
      rows1,
      columns1,
      columns2,
      columns3,
      columns4,
      columns5,
      columns6,
      rows2,
      rows3,
      rows4,
      rows5,
      rows6,
      pagination,
      disable,
      getDados,
      handleRequest,
      total,
      dadosGraficoBarChartConsumo,
      dadosGraficoBarChartAtendimento,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getFiltros,
      filter,
      movimento,
      dadosGraficoTipoIntegracao,
      getTop10Funcionarios,
      dadosGraficoTipoCentro,
      dadosGraficoTipoProduto,
      dadosGraficoTipoCentroNome,
      dadosGraficoTipoContas,
      dadosGraficoTipoGrupo,
      highlights,
      top,
      data,
      formatarPreco,
      formatarInteiro,
    };
  },
};
</script>

<style scoped>
.charts-section {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.charts-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: start;
}

.chart-item {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chart-item .q-table {
  height: 100%;
}

@media (max-width: 1024px) {
  .charts-grid {
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .charts-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .charts-section {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
}

.chart-item:nth-child(2) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabela-tamanho-fixo {
  min-height: 500px;
}

.status-circulo {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}
</style>
